document.addEventListener('DOMContentLoaded', function() {
  const loginModal = document.querySelector('.login-modal');
  
  if (!loginModal) return;

  const closeButton = loginModal.querySelector('.modal-header-button');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      loginModal.remove();
    });
  }

  const guestButton = loginModal.querySelector('.login-modal__content-actions .login-modal__guest');
  if (guestButton) {
    guestButton.addEventListener('click', function(e) {
      e.preventDefault();
      loginModal.remove();
    });
  }
});

